module.exports = __webpack_public_path__ + "img/category_8.a48b42ae.png";